import { ICustomer } from "../customer";
import { IListCustomer, IListCustomerData } from "./listCustomer.types";

export class ListCustomer implements IListCustomer {
    customers: ICustomer[];
    nextToken?: string | undefined;

    constructor(data: any) {
        this.customers = data.items;
        this.nextToken = data.nextToken;
    }
    data(): IListCustomerData {
        return Object.assign({}, this)
    }
}